import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/full-logo.png';

const originalColors = [
  "#ffc0cb",
  "#ffb6c1",
  "#ff69b4",
  "#ff1493",
  "#db7093",
  "#c71585",
  "#ffa07a",
  "#e9967a",
  "#f08080",
  "#cd5c5c",
  "#dc143c",
  "#b22222",
  "#8b0000",
  "#ff0000",
  "#ff4500",
  "#ff6347",
  "#ff7f50",
  "#ff8c00",
  "#ffa500",
  "#ffd700",
  "#ffff00",
  "#ffffe0",
  "#fffacd",
  "#fafad2",
  "#ffefd5",
  "#ffe4b5",
  "#ffdab9",
  "#eee8aa",
  "#f0e68c",
  "#bdb76b",
  "#ffebcd",
  "#ffe4c4",
  "#ffdead",
  "#f5deb3",
  "#deb887",
  "#d2b48c",
  "#bc8f8f",
  "#daa520",
  "#b8860b",
  "#cd853f",
  "#d2691e",
  "#8b4513",
  "#a0522d",
  "#a52a2a",
  "#800000",
  "#556b2f",
  "#808000",
  "#6b8e23",
  "#9acd32",
  "#32cd32",
  "#00ff00",
  "#7cfc00",
  "#adff2f",
  "#00ff7f",
  "#00fa9a",
  "#90ee90",
  "#98fb98",
  "#8fbc8f",
  "#3cb371",
  "#2e8b57",
  "#228b22",
  "#008000",
  "#006400",
  "#66cdaa",
  "#00ffff",
  "#afeeee",
  "#7fffd4",
  "#40e0d0",
  "#48d1cc",
  "#00ced1",
  "#20b2aa",
  "#5f9ea0",
  "#008b8b",
  "#008080",
  "#b0c4de",
  "#87ceeb",
  "#87cefa",
  "#00bfff",
  "#1e90ff",
  "#6495ed",
  "#4682b4",
  "#4169e1",
  "#0000ff",
  "#0000cd",
  "#00008b",
  "#000080",
  "#191970",
  "#d8bfd8",
  "#dda0dd",
  "#ee82ee",
  "#da70d6",
  "#ff00ff",
  "#ba55d3",
  "#9370db",
  "#8a2be2",
  "#9400d3",
  "#9932cc",
  "#8b008b",
  "#800080",
  "#4b0082",
  "#483d8b",
  "#6a5acd",
  "#f0fff0",
  "#f0f8ff",
  "#f5f5f5",
  "#f5f5dc",
  "#fffff0",
  "#faebd7",
  "#faf0e6",
  "#fff0f5",
  "#ffe4e1",
  "#dcdcdc",
  "#d3d3d3",
  "#c0c0c0",
  "#a9a9a9",
  "#808080",
  "#696969",
  "#778899",
  "#2f4f4f",
  "#000000"
]

const shuffledColors = [
  "#00ff00",
  "#bdb76b",
  "#191970",
  "#ffe4c4",
  "#1e90ff",
  "#ffff00",
  "#dcdcdc",
  "#8b0000",
  "#b0c4de",
  "#800000",
  "#2e8b57",
  "#fafad2",
  "#eee8aa",
  "#faf0e6",
  "#f5f5f5",
  "#8a2be2",
  "#40e0d0",
  "#7fffd4",
  "#f0e68c",
  "#e9967a",
  "#000080",
  "#f0fff0",
  "#deb887",
  "#32cd32",
  "#4682b4",
  "#48d1cc",
  "#696969",
  "#87ceeb",
  "#00fa9a",
  "#ffa07a",
  "#ffd700",
  "#dc143c",
  "#faebd7",
  "#008000",
  "#ffe4e1",
  "#d2691e",
  "#00ffff",
  "#ffc0cb",
  "#00bfff",
  "#9acd32",
  "#d2b48c",
  "#0000ff",
  "#ba55d3",
  "#c0c0c0",
  "#87cefa",
  "#ff8c00",
  "#db7093",
  "#ffdab9",
  "#fff0f5",
  "#20b2aa",
  "#d8bfd8",
  "#008b8b",
  "#c71585",
  "#800080",
  "#f0f8ff",
  "#a52a2a",
  "#b8860b",
  "#f08080",
  "#adff2f",
  "#6b8e23",
  "#fffff0",
  "#dda0dd",
  "#008080",
  "#006400",
  "#ff7f50",
  "#6a5acd",
  "#ff00ff",
  "#556b2f",
  "#00008b",
  "#5f9ea0",
  "#9932cc",
  "#ff0000",
  "#7cfc00",
  "#ff6347",
  "#6495ed",
  "#ff1493",
  "#90ee90",
  "#da70d6",
  "#9370db",
  "#ffebcd",
  "#fffacd",
  "#f5f5dc",
  "#98fb98",
  "#ff4500",
  "#000000",
  "#f5deb3",
  "#00ff7f",
  "#808080",
  "#ffdead",
  "#daa520",
  "#2f4f4f",
  "#ffefd5",
  "#cd5c5c",
  "#a9a9a9",
  "#ee82ee",
  "#afeeee",
  "#0000cd",
  "#bc8f8f",
  "#228b22",
  "#808000",
  "#778899",
  "#483d8b",
  "#8fbc8f",
  "#4b0082",
  "#ffe4b5",
  "#66cdaa",
  "#a0522d",
  "#d3d3d3",
  "#4169e1",
  "#ff69b4",
  "#ffffe0",
  "#b22222",
  "#9400d3",
  "#ffb6c1",
  "#ffa500",
  "#cd853f",
  "#00ced1",
  "#8b008b",
  "#8b4513",
  "#3cb371"
]

const Home = () => {

  // const [colors, setColors] = useState([]);

  useEffect(() => {
    document.title = "MSTD SIG - Inicio";
  }, [])

  // useEffect(() => {
  //   setColors(shuffledColors);
  // }, [])

  // useEffect(() => {
  //   let colorsCopy = originalColors;    
  //   for (let i = colorsCopy.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [colorsCopy[i], colorsCopy[j]] = [colorsCopy[j], colorsCopy[i]];
  //   }
  //   console.log(colorsCopy);
  //   setColors(colorsCopy);
  // }, [])

  // useEffect(() => {
  //   let layersData = [];
  //   let diffValues = [];
  //   let fixedValues = sancarlosLayersData.sort((a, b) => a.layerData.defaultStyle.name.localeCompare(b.layerData.defaultStyle.name, 'es', {numeric: true}))
  //   fixedValues.forEach((item, itemIdx) => {
  //     layersData.push({ 
  //       pos: itemIdx, 
  //       datastoreName: item.dataStore.name, 
  //       layerName: item.layerData.name, 
  //       styleTypeName: item.layerData.defaultStyle.name, 
  //       coloredStyleName: ('mstd_default_' + item.layerData.defaultStyle.name + '_')
  //     })
  //     // console.log(itemIdx, item.dataStore.name, item.layerData.name, item.layerData.defaultStyle.name);
  //     let foundPos = diffValues.findIndex(v => item.layerData.defaultStyle.name === v.styleName)
  //     if (foundPos !== -1) {
  //       diffValues[foundPos].count++;
  //     } else {
  //       diffValues.push({ styleName: item.layerData.defaultStyle.name, count: 1 });
  //     }
  //   })
  //   console.log(layersData);
  //   console.log(diffValues);
  // }, [])

  return (
    <div className="d-flex flex-column h-100 m-3 overflow-auto">
      <div className="d-flex flex-md-1 align-items-center justify-content-center py-2 py-md-3">
        <img src={logo} alt="MSTD" className="w-auto"/>
      </div>
      <div className="ms-3 mt-5 fs-4">MSTD - Proyectos SIG</div>
      <div className="d-flex flex-column ms-3 mt-5">
        <span className="my-2"><Link to='/map/La Unión 12-24'> La Unión 12-24 </Link></span>
        <span className="my-2"><Link to='/map/Santa Juana 03-25'> Santa Juana 03-25 </Link></span>
        <span className="my-2"><Link to='/map/San Carlos 07-25'> San Carlos 07-25 </Link></span>
      </div>
      {/* <div className="d-flex overflow-auto">
        <div className="d-flex flex-wrap">
          {colors.map((item, itemIdx) => (
            <div key={itemIdx} style={{ backgroundColor: item, width: 80, height: 60 }}>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  )
}

export default Home;